/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_OrganizationInputs */

const cs_draft_group_organization = /** @type {(inputs: Draft_Group_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentura`)
};

const en_draft_group_organization = /** @type {(inputs: Draft_Group_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency`)
};

/**
* | output |
* | --- |
* | "Agency" |
*
* @param {Draft_Group_OrganizationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_organization = /** @type {((inputs?: Draft_Group_OrganizationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_OrganizationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_organization(inputs)
	return cs_draft_group_organization(inputs)
});